module.exports = __webpack_public_path__ + "static/media/wwm.b523484f.csv";